// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => Material.loadInternal(), entryList => {
        Material.θentryList.set(entryList)
        Material.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class Material {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["name", "alternativeNames"] as const,
        allPropertyNames: ["id", "name", "alternativeNames"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<Material.Id | null>;
    static readonly Id = Number;
    static ids: Material.Id[] = [] as any;
    static idsAndDisplayValues: Record<Material.Id, string> = {} as any;
    static θentryList = signal<Material.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<Material.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'id';
    [immerable] = true;
    readonly θname = computed(() => {
        const id = this.θid()
        return id !== null ? Material.getEntryMap()[id]?.name : undefined
    });
    readonly θalternativeNames = computed(() => {
        const id = this.θid()
        return id !== null ? Material.getEntryMap()[id]?.alternativeNames : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return Material[BoInfoSymbol]
    }

    get __type(): 'Orders.Material' {
        return 'Orders.Material'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.Material' {
        return 'Orders.Material'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): Material.Id | null {
        return this.θid()
    }

    set id(id: Material.Id | Material | null) {
        if (id !== null && typeof id == 'object') { id = id.id }



        this.θid.set(id as Material.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): Material.Id[] {
        return Material.ids
    }

    get idsAndDisplayValues(): Record<Material.Id, string> {
        return Material.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[Material.$displayProperty])
    }

    get name() {
        return this.θname()
    }

    get alternativeNames() {
        return this.θalternativeNames()
    }

    constructor(idOrObject: Material.Id | Material | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): Material.Entry[] {
        return This.Material.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): Material.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: Material.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof Material.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = Material.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<Material.Entry[]> {
        async function getDynamicEntries() {
            try {
                return ExecutionService.executeMethodAndReturnData<any[]>('StaticEntity', 'Orders', 'Material', undefined, 'getEntryList', [])
            } catch (err: any) {
                console.error('Error loading dynamic entries for Orders.Material:', err)
                return []
            }

        }

        const dynamicEntryList = await getDynamicEntries()
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new Material(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: Material.Id | Material | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as Material.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: Material.Id | Material) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<Material.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.Material yet:', err.message)
            //throw err
        })
    }

    static θgetStaticEntryList() {
        return Object.freeze([

        ] as Material.Entry[]) as Material.Entry[]
    }
}
jsonClass('Orders.Material')(Material)

export const MaterialθId = Number;

export type MaterialθId = number;

export namespace Material {
    export type Id = number

    export interface Entry {
        id: Material.Id;
        name: string;
        alternativeNames: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => Material.load(true))
